import { SlotType } from '#record/model'
import { BiLayer } from 'react-icons/bi'
import { GiIceShield } from 'react-icons/gi'



export const priorTrxauthzType = 'priortrxauthz'

export const patchedTypes : SlotType[]  = [priorTrxauthzType]

export const PriorTrxAuthzIcon = GiIceShield
export const PriorTrxTypeIcon = BiLayer
